import { assertNever } from 'owa-assert';
import { FluidLoadSource, FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';

// This does not currently do anything. But it exists in telemetry with only one
// value for legacy reasons. It is being kept becasue in the near future we will be
// using the generic loader, which will have different values here.
export function convertFluidLoadSourceToString(source: FluidLoadSource): string {
    switch (source) {
        case FluidLoadSource.Fluid:
            return 'Fluid';
        default:
            return assertNever(source);
    }
}

export function convertFluidLoadOwaScenarioToString(scenario: FluidLoadOwaScenario): string {
    switch (scenario) {
        case FluidLoadOwaScenario.ReadingPane:
            return 'ReadingPane';
        case FluidLoadOwaScenario.ComposeWithNewComponent:
            return 'ComposeWithNewComponent';
        case FluidLoadOwaScenario.ComposeWithExistingComponent:
            return 'ComposeWithExistingComponent';
        default:
            return assertNever(scenario);
    }
}

export function convertFluidOwaSourceToString(source: FluidOwaSource): string {
    switch (source) {
        case FluidOwaSource.MailReadingPane:
            return 'MailReadingPane';
        case FluidOwaSource.MailCompose:
            return 'MailCompose';
        case FluidOwaSource.CalendarReadingPane:
            return 'CalendarReadingPane';
        case FluidOwaSource.CalendarCompose:
            return 'CalendarCompose';
        case FluidOwaSource.Timestream:
            return 'Boards';
        case FluidOwaSource.AgendaEditor:
            return 'AgendaEditor';
        case FluidOwaSource.MailCalendarCard:
            return 'MailCalendarCard';
        case FluidOwaSource.None:
            return 'Unknown';
        default:
            return assertNever(source);
    }
}
